<script setup lang="ts">
import CareerContent from './Components/CareerContent.vue';

</script>

<template>
    <CareerContent />
</template>
